import { IUser, IUserInformation } from "../../common/constants/app.dto";

export interface IUserState extends IUser {
    favorites: any[];
}

export const userInformation: IUserInformation = {
    name: "",
    lastName: "",
    gender: "",
    nationality: "",
    email: "",
    cellPhone: "",
    documentType: "",
    documentValue: "",
    birthAt: "",
    lastRole: "",
    salaryRange: 0,
    hasImmediateAvailability: false,
    hasWorkEquipment: false,
    hasImmediateTravel: false,
    secondaryStudy: true,
    mobility: false,
    hasDriverLicense: false,
}

export const userInitialState: IUserState = {
    id: "",
    imageUrl: "",
    curriculumDocumentUrl: "",
    nameCurriculumDocument: "",
    isLogged: false,
    addresses: [],
    formationInfo: [],
    knowledges: [],
    workExperience: [],
    evaluation: [],
    favorites: [],
    ...userInformation,
};

export type UserAttrNameState = keyof typeof userInitialState;
